import { all, fork, put, select, takeLatest } from 'redux-saga/effects'

import {
  handleUpdateUser,
  CONFIRM_UPDATE_USER_ACTION,
  REQUEST_UPDATE_USER_REGISTRATION_SUCCESS,
  REQUEST_UPDATE_USER_REGISTRATION_FAILURED,
  handleUpdateUserAgent,
  handleUpdateUserVendor,
  REQUEST_UPDATE_USER_REGISTRATION_AGENT_SUCCESS,
  REQUEST_UPDATE_USER_REGISTRATION_AGENT_FAILURED,
  REQUEST_UPDATE_USER_REGISTRATION_VENDOR_SUCCESS,
  REQUEST_UPDATE_USER_REGISTRATION_VENDOR_FAILURED,
  fetchUserDetails,
  fetchAllVendorCategoryUpdate,
  GET_ALL_VENDOR_CATEGORY_UPDATE_ACTION,
  REQUEST_ALL_VENDOR_CATEGORY_UPDATE_SUCCESS,
  handleUploadDreLicense,
  handleUploadDriverLicense,
  UPLOAD_FILE_DRE_LICENSE_ACTION,
  UPLOAD_FILE_DRIVER_LICENSE_ACTION,
  UPLOAD_PHOTO_UPDATE_USER_ACTION,
  handleUploadUpdateUser,
} from '.'
import { ROUTE_LIST_REGISTRATION } from '../routing'
import { redirect } from 'redux-first-router'
import { showToastAlert } from '../app'
import { TypeOfUser, UserStatus } from 'utils/constants'

function* initPage() {
  const { location } = yield select()
  const { payload } = location
  const { id } = payload
  yield put(fetchUserDetails(id))
}

function* updateUser() {
  yield takeLatest(CONFIRM_UPDATE_USER_ACTION, function* (action) {
    const { payload } = action
    const { typeOfUser } = payload
    const isAdminOrUser = typeOfUser === TypeOfUser.Admin || typeOfUser === TypeOfUser.User
    const isAgent =
      typeOfUser === TypeOfUser.RealifiAgent || typeOfUser === TypeOfUser.NonRealiFiAgent

    const commonInfo = {
      userId: payload.userId,
      avatarUrl: payload.avatarUrl,
      firstName: payload.firstName,
      lastName: payload.lastName,
      dateOfBirth: payload.dateOfBirth,
      phone: payload.phone,
      status: payload.status,
      userTag: payload.userTag,
      typeOfUser: payload.typeOfUser,
    }
    if (isAdminOrUser) {
      yield put(handleUpdateUser(commonInfo))
    } else if (isAgent) {
      yield put(
        handleUpdateUserAgent({
          ...commonInfo,
          agentName: payload.agentName,
          license: payload.license,
          agentEmail: payload.agentEmail,
          socialMedia: payload.socialMedia,
          description: payload.description,
          commission: payload.commission,
          businessName: payload.businessName,
          listAgentMlsId: payload.listAgentMlsId,
          DREExpirationDate: payload.DREExpirationDate,
          DRELicenseURL: payload.DRELicenseURL,
          driverLicenseURL: payload.driverLicenseURL,
        }),
      )
    } else {
      yield put(
        handleUpdateUserVendor({
          ...commonInfo,
          businessName: payload.businessName,
          primaryContact: payload.primaryContact,
          license: payload.license,
          vendorEmail: payload.vendorEmail,
          vendorLocation: payload.vendorLocation,
          vendorType: payload.vendorType,
          description: payload.description,
        }),
      )
    }
  })

  yield takeLatest(REQUEST_UPDATE_USER_REGISTRATION_SUCCESS, function* (action) {
    yield put(redirect({ type: ROUTE_LIST_REGISTRATION }))
    yield put(showToastAlert(action.payload.message))
  })

  yield takeLatest(REQUEST_UPDATE_USER_REGISTRATION_FAILURED, function* (action) {
    yield put(redirect({ type: ROUTE_LIST_REGISTRATION }))
    yield put(showToastAlert(action.payload.data.message, 'error'))
  })

  yield takeLatest(REQUEST_UPDATE_USER_REGISTRATION_AGENT_SUCCESS, function* (action) {
    yield put(redirect({ type: ROUTE_LIST_REGISTRATION }))
    yield put(showToastAlert(action.payload.message))
  })

  yield takeLatest(REQUEST_UPDATE_USER_REGISTRATION_AGENT_FAILURED, function* (action) {
    yield put(redirect({ type: ROUTE_LIST_REGISTRATION }))
    yield put(showToastAlert(action.payload.data.message, 'error'))
  })

  yield takeLatest(REQUEST_UPDATE_USER_REGISTRATION_VENDOR_SUCCESS, function* (action) {
    yield put(redirect({ type: ROUTE_LIST_REGISTRATION }))
    yield put(showToastAlert(action.payload.message))
  })

  yield takeLatest(REQUEST_UPDATE_USER_REGISTRATION_VENDOR_FAILURED, function* (action) {
    yield put(redirect({ type: ROUTE_LIST_REGISTRATION }))
    yield put(showToastAlert(action.payload.data.message, 'error'))
  })

  yield takeLatest(GET_ALL_VENDOR_CATEGORY_UPDATE_ACTION, function* (action) {
    yield put(fetchAllVendorCategoryUpdate(action.payload))
  })

  yield takeLatest(UPLOAD_FILE_DRE_LICENSE_ACTION, function* (action) {
    const { payload } = action
    yield put(handleUploadDreLicense(payload.file))
  })

  yield takeLatest(UPLOAD_FILE_DRIVER_LICENSE_ACTION, function* (action) {
    const { payload } = action
    yield put(handleUploadDriverLicense(payload.file))
  })

  yield takeLatest(UPLOAD_PHOTO_UPDATE_USER_ACTION, function* (action) {
    const { payload } = action
    yield put(handleUploadUpdateUser(payload.file))
  })

  yield takeLatest(REQUEST_ALL_VENDOR_CATEGORY_UPDATE_SUCCESS, function* (action) {
    const { metadata } = action.payload
    const { page, limit, total } = metadata
    if (page * limit < total) {
      yield put(fetchAllVendorCategoryUpdate({ page: page + 1, limit, status: UserStatus.Active }))
    }
  })
}

export default function* loadUpdateUserRegistration() {
  yield all([fork(initPage), fork(updateUser)])
}
